module.exports = __webpack_public_path__ + "img/moutarde.9a884b8f.svg";